<template>
  <div class="complex-wrap">
    <div style="font-size: 12px;">拖动可调整顺序</div>
    <MutiImgUpload
      ref="imgs"
      :mainImgNums="0"
      :limitNums="5"
      :imgs="tjbForm[key]"
      v-bind="extraAttr"
      @change="onChange"
       />
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'

import storeMixins from '../store-mixins'

export default {
  components: {
    MutiImgUpload
  },
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name
    },
    extraAttr() {
      return this.props.extraAttr || {}
    }
  },
  methods: {
    onChange(v) {
      const newFormFields = {}
      newFormFields[this.key] = v
      this.updateTjbForm(newFormFields)
    }
  },
  mounted() {
    const watcher = this.$watch('extraAttr', (v) => {
      if (v._needLimit) {
        this.$parent.rules.push({
          validator: async (rule, value, callback) => {
            let errMsg = await this.$refs.imgs.method_validImage()
            if (errMsg) {
                callback(new Error(errMsg));
            } else {
                callback();
            }
          }
        })
      }
      this.$nextTick(() => {
        watcher && watcher();
      })
    }, {
      immediate: true
    })
  }
};
</script>

<style lang="scss" scoped>

</style>